<template>
	<div>
		<b-navbar toggleable="lg" type="dark"  class="customNavHeader">
			<b-navbar-nav>
				<span class="sgHeaderText">{{navText}} - Store Id: {{ $store.state.storeId}} </span>
			</b-navbar-nav>


			<b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

			<b-collapse id="nav-collapse" is-nav>
				<!-- Right aligned nav items -->

				<b-navbar-nav class="ml-auto sgHeaderText">
					<b-nav-item @click="logOut()" v-if="!showCollapse">Logout</b-nav-item>
					<b-nav-item   v-if="showCollapse && this.storeId<= 2" @click="updateSgSetting(storeId, 'strClickAndCollect', 'created')" right>
						Reset store
					</b-nav-item>
					<b-nav-item   v-if="showCollapse  && showDashboard" :href='this.$store.state.baseUrl + "/qr-admin/dashboard.php"' right>
						Dashboard
					</b-nav-item>
					<b-nav-item   v-if="showCollapse" to="../../manageOrders">
						View Orders
					</b-nav-item>
					<b-nav-item   v-if="showCollapse" to="../../adminSlots">
						Manage Slots
					</b-nav-item>
					<b-nav-item-dropdown to="ccsettings" text="Settings" right class="settingsNavText"  v-if="showCollapse">						
							<b-dropdown-item to="../../configureSlots">Configure Slots</b-dropdown-item>
							<b-dropdown-item to="../../ccsettings">Click&Collect Settings</b-dropdown-item>
							<b-dropdown-item to="../../reports">Reports</b-dropdown-item>						
							<b-dropdown-item @click="logOut()">Logout</b-dropdown-item>
					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-collapse>			
		</b-navbar>
	</div>
</template>
<script>
import {mixin} from '../mixins/clickAndCollectMixins'
import {RepositoryFactory} from '../api/RepositoryFactory'
const SettingsRepoPost = RepositoryFactory.post('settings')
export default{
name: 'NavHeader',
props: ['navText'],
mixins: [mixin],
data(){
	return{
		storeId : this.$store.state.storeId,
		showDashboard: (this.$store.state.subscriptionType == "clickandcollect")? false : true,
		//showCollapse: this.$store.state.showCollapse
	}
},
methods:{
	async logOut(){
		
		// set store.state.loggedIn to false
		this.$store.commit('logOut')	

		// delete the current secToken from the db
		var payload = new FormData();
		payload.append('setting', 'secToken')
		payload.append('storeId', this.storeId)
		payload.append('newValue', "")			
		await SettingsRepoPost.postUpdateStoreSetting(payload)
		
		// clear the local persisted state
		window.localStorage.clear();		
		
		// Redirect to login page
		this.$nextTick().then(() => {
			window.location = this.$store.state.baseUrl+ "qr-admin/logout.php"		
		});			
	}	
},
computed:{
showCollapse: function(){  // hides the main navigation from the quickstart vue
return (this.$route.name == 'quickStart')? false : true
}
}
}
</script>
<style scoped>
	.sgHeaderText, .sgHeaderText a{
		color: #fff !important
	}

	.qsLogout{
	float: right;
	}

	.customNavHeader{
		text-align: left;
		background-color: #AA090A;
	}

</style>
